import script from "./FilePondField.vue?vue&type=script&setup=true&lang=js"
export * from "./FilePondField.vue?vue&type=script&setup=true&lang=js"

import "./FilePondField.vue?vue&type=style&index=0&id=888797b8&scoped=true&lang=css"

import exportComponent from "/home/datakepler/public_html/deploy-cache/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-888797b8"]])

export default __exports__